export default "__VITE_ASSET__KNgv42bA__"